import React, { useEffect } from 'react';
import { Container, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import clsx from 'clsx';
import useStyles from './styles.ts';
import * as GuiStateSelectors from 'app/selectors/guiStateSelectors.ts';
import { CompanyManagementActions } from 'app/actions/companyManagment/companyManagementActions.ts';
import { useIsHeiDomain } from 'app/hooks/useIsHeiDomain.ts'; // Added import

type MainLoggedProps = {
  children: React.ReactNode;
};

const MainLogged: React.FC<MainLoggedProps> = ({ children }) => {
  const dispatch = useDispatch();
  const isHeiDomain = useIsHeiDomain(); // Added hook

  const isSidebarOpen = useSelector(GuiStateSelectors.sideBarStateSelector);

  const classes = useStyles();

  useEffect(() => {
    dispatch(CompanyManagementActions.getCompanies());
  }, [dispatch]);

  // Determine container styles based on isHeiDomain
  const containerWrapperStyle = isHeiDomain ? { height: '100%', width: '100%' } : {};
  const containerStyle = isHeiDomain
    ? { height: '100%', overflow: 'auto', marginLeft: 0, width: '100%' }
    : {};

  return (
    <Box
      className={!isHeiDomain ? classes.containerWrapper : undefined}
      style={containerWrapperStyle} // Apply conditional style
      display="flex"
    >
      <Container
        className={clsx(!isHeiDomain && classes.container, {
          [!isHeiDomain && classes.container_sidebar_closed]: !isSidebarOpen && !isHeiDomain,
        })}
        style={containerStyle} // Apply conditional style
        maxWidth={false}
        disableGutters
      >
        {children}
      </Container>
    </Box>
  );
};

export default MainLogged;
